import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { calculateToDatePlus } from "../../../utils/utils";
import styles from "./NewAgentSearchPage.module.scss";
import { SvgRightIcon, SvgSearch } from "../../../utils/svgIcons";
import NewSearchSateInput from "../../NewSearchSateInput/NewSearchSateInput";
import DatePicker from "react-datepicker";
import HomePageNewSearchSateInput from "../../NewSearchSateInput/HomePageNewSearchSateInput";
import { format } from "date-fns";
import GuestDetailsPopup from "../NewUiSearchForm/NewUiSearchFormHotels/GuestDetailsPopup";
import { toast } from "react-toastify";

function NewUIAgentSearchFormHotels({ topRadios }) {
  const [dataFromChild, setDataFromChild] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [bookingData, setBookingData] = useState({});
  const [show, setShow] = useState(false);
  const location = useLocation();

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      // hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges, // Assign the array of child ages
    };
    // console.log(hotelData, "data hotel")
    setBookingData(data);
    // postBookingData(data);
  }, [location.search]);

  const getDataFromChild = (data, resultArray, selectedType) => {
    setDataFromChild(data);
    setSelectedType(selectedType);
  };
  // console.log(dataFromChild, "getDataFromChild");

  const handleStartDateChange = ([date]) => {
    setStartDate(date);
    // Automatically set end date to the selected start date if it's not already set
    if (!endDate || date > endDate) {
      setEndDate(date);
    }
  };

  const handleEndDateChange = ([date]) => {
    setEndDate(date);
  };

  const [guestDetails, setIsguestDetails] = useState(false);
  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectDates, setselectDates] = useState(false);

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });
  const navigate = useNavigate();

  // popup details
  const [storeRoomsData, setStoreRoomsData] = useState([
    { id: 1, adult: 2, children: [] },
  ]);
  const [adult, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);
  const [rooms, setRooms] = useState(1);

  // const addRoom = () => {
  //   if (storeRoomsData.length >= 6) return;
  //   const newRoomId = storeRoomsData.length + 1;
  //   const newRooms = [
  //     ...storeRoomsData,
  //     { id: newRoomId, adult: 1, children: [] },
  //   ];
  //   setStoreRoomsData(newRooms);
  //   setRooms(newRooms.length); // Update the room count
  //   updateTotalAdults(newRooms);
  // };

  const addRoom = () => {
    setStoreRoomsData((prevRooms) => {
      if (prevRooms.length >= 6) return prevRooms;

      const newRoomId =
        prevRooms.length > 0 ? prevRooms[prevRooms.length - 1].id + 1 : 1;
      const newRooms = [
        ...prevRooms,
        { id: newRoomId, adult: 1, children: [] },
      ];

      setRooms(newRooms.length);
      updateTotalAdults(newRooms);

      return newRooms;
    });
  };

  const removeRoom = (roomId) => {
    const newRooms = storeRoomsData.filter((room) => room.id !== roomId);
    setStoreRoomsData(newRooms);
    setRooms(newRooms.length); // Update the room count
    updateTotalAdults(newRooms);

    const childrens = newRooms?.flatMap((child) => child?.children);

    setChildren(childrens?.length);
  };

  const updateTotalAdults = (updatedRooms) => {
    const totalAdults = updatedRooms.reduce((sum, room) => sum + room.adult, 0);
    setAdults(totalAdults);
  };

  const onAdultIncrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.min(room.adult + 1, 4) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const onAdultDecrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.max(room.adult - 1, 1) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const addChildAge = (roomId, age) => {
    const room = storeRoomsData.find((room) => room.id === roomId);
    if (room && room.children.length >= 3) {
      toast.error("You can add a maximum of 3 children in one room.");
      return;
    }

    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? room.children.length < 3
            ? {
                ...room,
                children: [...room.children, age],
                showGuestDetailsPopup: !room.showGuestDetailsPopup,
              }
            : room
          : room
      )
    );

    // if (childAge.length < 3) {
    setChildren(Number(children) + 1);
    setChildAge([...childAge, age]);
    // }
  };

  const removeChild = (roomId, indexToRemove) => {
    let removedAge;
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          removedAge = room.children[indexToRemove];
          return {
            ...room,
            children: room.children.filter(
              (_, index) => index !== indexToRemove
            ),
          };
        }
        return room;
      })
    );
    setChildren(children - 1);
    setChildAge(
      childAge.filter((_, index) => index !== childAge.indexOf(removedAge))
    );
  };

  const toggleGuestDetailsPopup = (roomId) => {
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? { ...room, showGuestDetailsPopup: !room.showGuestDetailsPopup }
          : room
      )
    );
  };
  // end popup details
  // STATES
  const [date, setDate] = useState(new Date());
  const [selectedRadio, setSelectedRadio] = useState("s");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });

  const showErrorToast = (message) => {
    alert(message); // You can use a better toast notification library
  };

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(calculateToDatePlus(new Date(), 1));

  // Date alterations
  const [loader, setLoader] = useState(false);

  // const [checkin, setCheckin] = useState({
  //   day: router.query.checkinDay || "",
  //   month: router.query.checkinMonth || "",
  //   year: router.query.checkinYear || "",
  // });

  // const [checkout, setCheckout] = useState({
  //   day: router.query.checkoutDay || "",
  //   month: router.query.checkoutMonth || "",
  //   year: router.query.checkoutYear || "",
  // });

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };

  // Effect to add click event listener when guestDetails is true
  useEffect(() => {
    if (guestDetails) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [guestDetails]);

  useEffect(() => {
    if (
      checkinDay &&
      checkinMonth &&
      checkinYear &&
      checkoutDay &&
      checkoutMonth &&
      checkoutYear
    ) {
      const formatDateToString = (year, month, day) => {
        const paddedMonth = String(month).padStart(2, "0");
        const paddedDay = String(day).padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
      };

      const checkInDateString = formatDateToString(
        checkinYear,
        checkinMonth,
        checkinDay
      );
      const checkOutDateString = formatDateToString(
        checkoutYear,
        checkoutMonth,
        checkoutDay
      );

      const checkInDate = new Date(checkInDateString);
      const checkOutDate = new Date(checkOutDateString);

      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }
  }, [
    checkinDay,
    checkinMonth,
    checkinYear,
    checkoutDay,
    checkoutMonth,
    checkoutYear,
  ]);

  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const handleSubmitButtonClickHandler = async (e) => {
    setIsguestDetails(false);
    setdestinationToggle(false);
    setselectDates(false);
    e.preventDefault();

    if (!startDate || !endDate) {
      showErrorToast("Fill required detail first");
      return;
    }

    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    try {
      const encodedRoomsData = encodeURIComponent(
        JSON.stringify(storeRoomsData)
      );
      await navigate(
        `/agent-search/?location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${selectedRadio}&storeRoomsData=${encodedRoomsData}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  // console.log("selectedType", selectedType);

  const handleSubmitButtonClickHandlerHotels = async (e) => {
    setIsguestDetails(false);
    setdestinationToggle(false);
    setselectDates(false);
    e.preventDefault();

    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }
    try {
      await navigate(
        // `/single-hotel/${selectedType?.id}?hotelId=${selectedType?.id}&location=${selectedType.location}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}&hotel_name=${selectedType.name}&hotel_address=${selectedType.location}`,
        `/single-hotel-search/${selectedType?.slug}/${
          selectedType?.id
        }?location=${
          selectedType?.location
        }&room=${rooms}&adult=${adult}&children=${children}&${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(endDate).getFullYear()}&hotel_name=${
          selectedType?.name
        }&hotel_address=${selectedType?.location}`,
        {
          state: {
            storeRoomsData: storeRoomsData,
          },
        }
        // single-hotel/1?hotelId=1&location=Shimla&room=1&adult=2&children=0&checkinDay=4&checkinMonth=10&checkinYear=2024&checkoutDay=5&checkoutMonth=10&checkoutYear=2024&hotel_name=Golden%20Fern%20Resort%20by%20Eco%20Hospitality&hotel_address=Kachi%20Ghatti,%20Shimla,%20Himachal%20Pradesh%20171010
      );
      // const url = `/single-hotel/${selectedType?.id}?hotelId=${selectedType?.id}&location=${selectedType.location}&room=1&adult=1&children=0&checkinDay=${selectedType.checkinDay}&checkinMonth=${selectedType.checkinMonth}&checkinYear=${selectedType.checkinYear}&checkoutDay=${selectedType.checkoutDay}&checkoutMonth=${selectedType.checkoutMonth}&checkoutYear=${selectedType.checkoutYear}&hotel_name=${selectedType.hotel_name}&hotel_address=${selectedType.hotel_address}`;

      // Open the new tab with the URL
      // window.open(url, "_blank");
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);
  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  // Function to add a child's age
  const handleAddChildAge = (age) => {
    setChildAge((prevAges) => {
      const newAges = [...prevAges, age];
      setChildren(newAges.length);
      return newAges;
    });
    setShowGuestDetailsPopup(false);
  };

  // Function to remove a child's age
  const handleRemoveChild = (indexToRemove) => {
    setChildAge((prevAges) => {
      const newAges = prevAges.filter((_, index) => index !== indexToRemove);
      setChildren(newAges.length);
      return newAges;
    });
  };
  return (
    <>
      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            <form
              className={styles.NewUiSearchFormWrapper}
              onSubmit={
                selectedType?.type === "hotel"
                  ? handleSubmitButtonClickHandlerHotels
                  : handleSubmitButtonClickHandler
              }
            >
              <div className={styles.widthOfDestination}>
                <label htmlFor="">City/Destination/Hotel</label>

                <HomePageNewSearchSateInput
                  onClick={() => setdestinationToggle(true)}
                  onDataChange={getDataFromChild}
                  setIsguestDetails={setIsguestDetails}
                  type="hotel"
                />
              </div>

              <div
                className={`${styles.leftLineBorder} ${styles.widthOfDestination} new_date_picker_react_js_custom_styling`}
                setStartDate={setStartDate}
              >
                <label>Dates</label>

                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={startDate}
                    onChange={(dates) => {
                      const [start, end] = dates;
                      setStartDate(start);
                      setEndDate(end);
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()} // Prevent past dates selection
                    dateFormat="dd MMM, yyyy"
                    placeholderText={`${format(
                      startDate,
                      "dd MMM, yyyy"
                    )} - ${format(endDate, "dd MMM, yyyy")}`}
                  />
                </div>
              </div>
              <div className={styles.leftLineBorder}>
                <label onClick={dropdownGuestDetails} className="search_label">
                  Room & Guest
                </label>
                <p
                  style={{ position: "relative" }}
                  className="dropdown-toggle search_form_input"
                  onClick={() => setdestinationToggle(true)}
                >
                  <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                    <div className="optionCounter"></div>
                    <span className="font_16" id="adult_count">
                      {adult}
                    </span>
                    <span className="font_12"> Adults,</span>{" "}
                    <span className="font_16" id="room_count">
                      {rooms}
                    </span>
                    <span className="font_12"> Rooms, </span>{" "}
                    <span className="font_16" id="child_count">
                      {children}
                    </span>
                    <span className="font_12"> Children</span>
                  </div>
                  {guestDetails && (
                    <GuestDetailsPopup
                      guestDetails={guestDetails}
                      setIsguestDetails={setIsguestDetails}
                      adult={adult}
                      setAdults={setAdults}
                      children={children}
                      setChildren={setChildren}
                      rooms={storeRoomsData}
                      setRooms={setStoreRoomsData}
                      onRoomsChange={setStoreRoomsData}
                      handleRoomsUpdate={setStoreRoomsData}
                      setChildAge={setChildAge}
                      onAdultChange={setAdults}
                      childAge={childAge}
                      removeRoom={removeRoom}
                      onAdultIncrease={onAdultIncrease}
                      onAdultDecrease={onAdultDecrease}
                      toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                      addRoom={addRoom}
                      addChildAge={addChildAge}
                      removeChild={removeChild}
                      availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                    />
                  )}
                </p>
              </div>

              <div className={styles.searchButtonDiv}>
                <button type="submit" className={styles.submitButton}>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_6855_8179"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                      >
                        <rect width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6855_8179)">
                        <path
                          d="M13.0284 13.7178L8.8412 9.53051C8.50787 9.80574 8.12453 10.0211 7.6912 10.1767C7.25786 10.3322 6.80959 10.41 6.34636 10.41C5.20692 10.41 4.24259 10.0155 3.45336 9.22651C2.66414 8.43751 2.26953 7.4734 2.26953 6.33418C2.26953 5.19507 2.66403 4.23063 3.45303 3.44085C4.24203 2.65118 5.20614 2.25635 6.34536 2.25635C7.48448 2.25635 8.44892 2.65096 9.2387 3.44018C10.0284 4.2294 10.4232 5.19374 10.4232 6.33318C10.4232 6.80929 10.3433 7.26401 10.1835 7.69735C10.0236 8.13068 9.81036 8.50757 9.5437 8.82801L13.7309 13.0152L13.0284 13.7178ZM6.34636 9.41018C7.20536 9.41018 7.93292 9.11207 8.52903 8.51585C9.12525 7.91974 9.42336 7.19218 9.42336 6.33318C9.42336 5.47418 9.12525 4.74662 8.52903 4.15051C7.93292 3.55429 7.20536 3.25618 6.34636 3.25618C5.48736 3.25618 4.75981 3.55429 4.1637 4.15051C3.56748 4.74662 3.26936 5.47418 3.26936 6.33318C3.26936 7.19218 3.56748 7.91974 4.1637 8.51585C4.75981 9.11207 5.48736 9.41018 6.34636 9.41018Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                  Search
                </button>
              </div>
            </form>
          </div>{" "}
        </div>
      </section>

      {(guestDetails || destinationToggle || selectDates) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
            setselectDates(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </>
  );
}

export default NewUIAgentSearchFormHotels;
